// The white and black (the black is really a dark grey) ['#FFFFFF,'#333333'] //
// The colors from color brewer: //
['#ffffd9','#edf8b1','#c7e9b4','#7fcdbb','#41b6c4','#1d91c0','#225ea8','#253494','#081d58']
// https://colorbrewer2.org/#type=sequential&scheme=YlGnBu&n=9

<template>
  <div id="haikumarine"  v-if="this.user!=''">
    <v-main>
      <v-card class="mx-auto" max-width="100%" max-height="300" outlined>
        <div>
          <l-map
            v-if="showMap && !isFetchingBoxes"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            :bounds="bounds"
            style="height: 300px; width: 100%"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
          >
            <l-tile-layer :url="url" :attribution="attribution" />
            <v-marker-cluster>
              <l-marker
                @click="clickDevice(item)"
                v-for="item in connectedDevices"
                :key="item.id"
                :lat-lng="[item.lat, item.lon]"
              />
              <l-marker
                @click="clickDevice(item)"
                v-for="item in disconnectedDevices"
                :key="item.id"
                :lat-lng="[item.lat, item.lon]"
                :icon="iconDisconnected"
              />
            </v-marker-cluster>
          </l-map>
        </div>
      </v-card>

      <v-card
        class="mx-auto"
        max-width="100%"
        outlined
        color="blue-grey darken-4"
      >
        <v-app-bar color="blue-grey darken-4" dark>
          <v-toolbar-title> Live - {{ currentSiteName }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col v-for="item in liveHits" :key="item.id" cols="11">
              <v-card color="teal darken-4" dark>
                <!-- var htmlText = '<a href="https://ebird.org/species/' + audioInfo[i].Species + '" target="_blank">' + 'audioInfo[i].Species' + '</a> '; -->
                <v-avatar class="ma-3" width="64" height="48" tile>
                  <img
                    :src="
                      'https://haikubox-images.s3.amazonaws.com/' +
                      item.spCode +
                      '.jpeg'
                    "
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  />
                </v-avatar>
                <v-card-title>{{ item.cn }}</v-card-title>
                <v-card-subtitle>{{ getEventText(item) }}</v-card-subtitle>
                <div v-if="item.wav">
                  <v-card-actions>
                    <v-btn
                      v-if="item.wav"
                      @click="play(item.wav)"
                      color="#7eccba"
                      light
                      >Play</v-btn
                    >
                    <v-btn
                      text
                      href="https://sarasotadolphin.org"
                      target="_blank"
                      >Learn More</v-btn
                    >
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card
        class="mx-auto"
        max-width="100%"
        outlined
        color="blue-grey darken-4"
      >
        <v-app-bar dark color="blue-grey darken-4">
          <v-toolbar-title>Recent - {{ currentSiteName }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col v-for="(item, index) in hits" :key="item.id">
              <v-card
                color="light-blue darken-4"
                class="mx-auto mx-auto"
                max-width="350"
                dark
              >
                <v-card-title>{{ item.cn }}</v-card-title>

                <v-card-subtitle>
                  {{ item.spCode }}
                  <!-- <v-avatar class="ma-3" size="180" tile> -->
                  <img
                    v-if="item.window == 'image'"
                    :src="
                      'https://haikubox-images.s3.amazonaws.com/' +
                      item.spCode +
                      '.jpeg'
                    "
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  />
                  <!-- </v-avatar> -->

                  <!-- <v-card-text
                          >confidence: {{ getScoreText(item) }}</v-card-text
                > -->
                  <div v-if="item.window == 'daily'">
                    <v-card-text class="ma-3 font-weight-white">
                      Past Day
                      <v-icon>mdi-music-note</v-icon>
                      <span
                        class="font-weight-white"
                        v-text="getHourlySpeciesCount(item.spCode)"
                      ></span>
                    </v-card-text>
                    <column-chart
                      :colors="['#90A4AE']"
                      :height="100"
                      :library="{
                        scales: {
                          xAxes: [
                            {
                              ticks: {
                                fontColor: '#ffffff',
                              },
                            },
                          ],
                          yAxes: [
                            {
                              ticks: {
                                fontColor: '#ffffff',
                              },
                            },
                          ],
                        },
                      }"
                      :data="getHourlySpecies(item.spCode)"
                    ></column-chart>
                  </div>

                  <div v-if="item.window == 'monthly'">
                    <v-card-text class="ma-3">
                      Past Month
                      <v-icon>mdi-music-note</v-icon>
                      <span
                        class="font-weight-white"
                        v-text="getDailySpeciesCount(item.spCode)"
                      ></span>
                    </v-card-text>
                    <div>
                      <column-chart
                        :colors="['#90A4AE']"
                        :height="100"
                        :library="{
                          scales: {
                            xAxes: [
                              {
                                ticks: {
                                  fontColor: '#ffffff',
                                },
                              },
                            ],
                            yAxes: [
                              {
                                ticks: {
                                  fontColor: '#ffffff',
                                },
                              },
                            ],
                          },
                        }"
                        :data="getDailySpecies(item.spCode)"
                      ></column-chart>
                    </div>
                  </div>

                  <div v-if="item.window == 'spectrogram'">
                    <Plotly
                      :data="item.spectrogram"
                      :layout="plotlyLayout"
                      :display-mode-bar="false"
                    ></Plotly>
                  </div>
                </v-card-subtitle>

                <v-row class="mb-1" no-gutters>
                  <v-col>
                    <v-avatar
                      class="mx-4"
                      size="24"
                      v-tooltip.bottom-start="'Image'"
                      @click="setWindow(index, 'image')"
                    >
                      <img
                        :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                        :src="
                          'https://haikubox-images.s3.amazonaws.com/' +
                          item.spCode +
                          '.jpeg'
                        "
                        onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                      />
                    </v-avatar>

                    <v-btn
                      icon
                      v-tooltip.bottom-start="'Day Chart'"
                      @click="setWindow(index, 'daily')"
                    >
                      <v-icon>mdi-chart-bar</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      v-tooltip.bottom-start="'Month Chart'"
                      @click="setWindow(index, 'monthly')"
                    >
                      <v-icon>mdi-chart-multiple</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      v-tooltip.bottom-start="'Spectrogram'"
                      @click="spectrogram(index, item.wav, 'Recent')"
                      v-if="item.wav && selectedDeviceAudioPrivate === false"
                    >
                      <v-icon>mdi-chart-bubble</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <div v-if="item.wav && selectedDeviceAudioPrivate === false">
                  <v-card-actions>
                    <v-btn @click="play(item.wav)" color="light-blue darken-1">
                      <v-icon class="mr-1" small>mdi-play-circle</v-icon>
                      {{ getEventText(item) }}
                    </v-btn>
                    <v-btn
                      text
                      href="https://sarasotadolphin.org"
                      target="_blank"
                      >Learn More</v-btn
                    >
                  </v-card-actions>
                  <v-container id="label_sound">
                    <v-overflow-btn
                      v-if="item.wav"
                      @change="labelHit(item)"
                      class="my-2"
                      :items="dropdown_class"
                      :background-color="
                        item.classLabel != null
                          ? 'light-blue darken-4'
                          : 'light-blue darken-1'
                      "
                      label="Label"
                      target="#label_sound"
                      v-model="item.classLabel"
                    ></v-overflow-btn>
                  </v-container>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card
        class="mx-2"
        max-width="100%"
        outlined
        color="blue-grey darken-4"
        v-if="soundscapes.length != 0"
        dark
      >
        <v-app-bar dark color="ffffd9">
          <v-toolbar-title>Soundscapes</v-toolbar-title>
        </v-app-bar>
        <v-row>
          <v-col v-for="(item, index) in soundscapes" :key="item.id">
            <div v-if="item.wav && selectedDeviceAudioPrivate === false">
              <div v-if="item.window == 'spectrogram'">
                <v-card-subtitle>
                <Plotly
                  :data="item.spectrogram"
                  :layout="plotlyLayout"
                  :display-mode-bar="false"
                ></Plotly>
                </v-card-subtitle>
              </div>
              <v-card-actions>
                <v-btn @click="play(item.wav)">
                  <v-icon class="mr-1" small>mdi-play-circle</v-icon>
                  {{ getEventText(item) }}
                </v-btn>
                <v-btn
                  icon
                  v-tooltip.bottom-start="'Spectrogram'"
                  @click="spectrogram(index, item.wav, 'Soundscape')"
                >
                  <v-icon>mdi-chart-bubble</v-icon>
                </v-btn>
              </v-card-actions>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <div v-if="selectedDeviceAudioPrivate === false">
        <v-card class="mx-auto" max-width="100%" outlined>
          <v-app-bar dark color="ffffd9">
            <v-toolbar-title>Help Improve Haikumarine</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-app-bar>
          <v-container>
            <v-row>
              <v-col v-for="item in allHits" :key="item.id">
                <v-card
                  dark
                  color="#385F73"
                  class="mx-auto mx-auto"
                  max-width="350"
                >
                  <v-avatar class="ma-3" width="64" height="48" tile>
                    <img
                      :src="
                        'https://haikubox-images.s3.amazonaws.com/' +
                        item.spCode +
                        '.jpeg'
                      "
                      onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                    />
                  </v-avatar>
                  <v-card-title>
                    {{ item.cn }}
                  </v-card-title>
                  <v-card-subtitle>{{ getEventText(item) }}</v-card-subtitle>
                  <v-card-actions>
                    <v-btn
                      v-if="item.wav"
                      @click="play(item.wav)"
                      color="#385F73"
                      >Play</v-btn
                    >
                    <v-btn
                      text
                      href="https://sarasotadolphin.org"
                      target="_blank"
                      >Learn More</v-btn
                    >
                  </v-card-actions>
                  <v-container id="label_all_sound">
                    <v-overflow-btn
                      v-if="item.wav"
                      @change="labelHit(item)"
                      :background-color="
                        item.classLabel != null ? 'accent' : 'darken'
                      "
                      class="my-2"
                      :items="dropdown_class"
                      label="Label"
                      target="#label_all_sound"
                      v-model="item.classLabel"
                    ></v-overflow-btn>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </div>

      <h3>{{ currentSiteName }}</h3>
      <v-card class="mx-auto pa-10" outlined>
        <v-app-bar dark color="blue">
          <v-toolbar-title>{{ currentSerial }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
        <v-card-subtitle>Status</v-card-subtitle>
        <div class="mx-auto pa-12">
          <line-chart
            :colors="['#fcba03']"
            :height="150"
            :min="30"
            :max="100"
            ytitle="CPU Temp"
            :library="{
              scales: {
                xAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
              },
            }"
            :data="cpuTempSeries"
          ></line-chart>
          <column-chart
            :colors="['#fcba03']"
            :height="150"
            :min="0"
            :max="2"
            ytitle="CPU GHz"
            :library="{
              scales: {
                xAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
              },
            }"
            :data="cpuFreqSeries"
          ></column-chart>
          <column-chart
            :colors="['#fcba03']"
            :height="150"
            :min="0"
            ytitle="ramdisk"
            :library="{
              scales: {
                xAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
              },
            }"
            :data="ramdiskSeries"
          ></column-chart>
          <line-chart
            :colors="['#fcba03']"
            :height="150"
            :min="-100"
            :max="0"
            ytitle="WiFi dBm"
            :library="{
              scales: {
                xAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      fontColor: '#000000',
                    },
                  },
                ],
              },
            }"
            :data="signalSeries"
          ></line-chart>
        </div>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Text Warnings</v-expansion-panel-header>
            <v-expansion-panel-content
              v-for="item in haikuboxStatus"
              :key="item.id"
            >
              <template v-if="item.warning != ''">
                Date: {{ item.createdAt }}
                {{ item.warning }}
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-main>
  </div>
</template>

<script>
import { API, Storage } from "aws-amplify";
import {
  hitBySerialByDate,
  listDeviceStates,
  dailyCountBySerialByDate,
  itemsBySerialByDate,
  statusByDate,
  getDeviceState,
  rawHaikumarineBySerialByDate,
} from "./graphql/queries";
import { createLabeledData } from "./graphql/mutations";
import { onCreateHit } from "./graphql/subscriptions";
import {
  haikuboxByOwner,
  haikuboxBySerial,
  haikuboxStateByType,
} from "./graphql/queries";
import { latLngBounds, latLng, icon } from "leaflet";

var moment = require("moment-timezone");

// const AudioContext = window.AudioContext || window.webkitAudioContext;
let context;
let source;
let compressor;
var audio = new Audio();

import { AudioContext, decodeAudioData } from "standardized-audio-context";
//const AudioContext = window.AudioContext || window.webkitAudioContext;

import { Plotly } from "vue-plotly";

var hann = [
  0.0, 3.77965773e-5, 1.51180595e-4, 3.4013491e-4, 6.04630957e-4, 9.44628746e-4,
  1.36007687e-3, 1.85091253e-3, 2.41706151e-3, 3.05843822e-3, 3.77494569e-3,
  4.56647559e-3, 5.43290826e-3, 6.3741127e-3, 7.38994662e-3, 8.48025644e-3,
  9.64487731e-3, 1.08836332e-2, 1.21963367e-2, 1.35827895e-2, 1.50427819e-2,
  1.65760932e-2, 1.81824916e-2, 1.98617342e-2, 2.16135671e-2, 2.34377255e-2,
  2.53339336e-2, 2.73019047e-2, 2.93413412e-2, 3.1451935e-2, 3.36333667e-2,
  3.58853068e-2, 3.82074146e-2, 4.05993391e-2, 4.30607187e-2, 4.55911813e-2,
  4.81903443e-2, 5.08578147e-2, 5.35931893e-2, 5.63960544e-2, 5.92659864e-2,
  6.22025514e-2, 6.52053053e-2, 6.82737943e-2, 7.14075543e-2, 7.46061116e-2,
  7.78689827e-2, 8.11956742e-2, 8.45856832e-2, 8.80384971e-2, 9.1553594e-2,
  9.51304424e-2, 9.87685015e-2, 1.02467221e-1, 1.06226043e-1, 1.10044397e-1,
  1.13921708e-1, 1.17857388e-1, 1.21850843e-1, 1.25901469e-1, 1.30008654e-1,
  1.34171776e-1, 1.38390206e-1, 1.42663307e-1, 1.46990432e-1, 1.51370928e-1,
  1.55804131e-1, 1.60289372e-1, 1.64825973e-1, 1.69413247e-1, 1.74050502e-1,
  1.78737036e-1, 1.8347214e-1, 1.88255099e-1, 1.9308519e-1, 1.97961681e-1,
  2.02883837e-1, 2.07850913e-1, 2.12862158e-1, 2.17916814e-1, 2.23014117e-1,
  2.28153297e-1, 2.33333576e-1, 2.38554171e-1, 2.43814294e-1, 2.49113148e-1,
  2.54449933e-1, 2.59823842e-1, 2.65234062e-1, 2.70679775e-1, 2.76160159e-1,
  2.81674384e-1, 2.87221617e-1, 2.92801019e-1, 2.98411747e-1, 3.04052952e-1,
  3.09723782e-1, 3.15423378e-1, 3.21150881e-1, 3.26905422e-1, 3.32686134e-1,
  3.38492141e-1, 3.44322565e-1, 3.50176526e-1, 3.56053138e-1, 3.61951513e-1,
  3.6787076e-1, 3.73809982e-1, 3.79768282e-1, 3.8574476e-1, 3.91738511e-1,
  3.97748631e-1, 4.03774209e-1, 4.09814335e-1, 4.15868096e-1, 4.21934577e-1,
  4.2801286e-1, 4.34102027e-1, 4.40201156e-1, 4.46309327e-1, 4.52425614e-1,
  4.58549094e-1, 4.64678841e-1, 4.70813928e-1, 4.76953428e-1, 4.83096412e-1,
  4.89241951e-1, 4.95389117e-1, 5.0153698e-1, 5.07684611e-1, 5.1383108e-1,
  5.19975458e-1, 5.26116815e-1, 5.32254225e-1, 5.38386758e-1, 5.44513487e-1,
  5.50633486e-1, 5.56745831e-1, 5.62849596e-1, 5.68943859e-1, 5.75027699e-1,
  5.81100196e-1, 5.87160431e-1, 5.93207489e-1, 5.99240456e-1, 6.05258418e-1,
  6.11260467e-1, 6.17245695e-1, 6.23213197e-1, 6.2916207e-1, 6.35091417e-1,
  6.41000339e-1, 6.46887944e-1, 6.52753341e-1, 6.58595644e-1, 6.6441397e-1,
  6.70207439e-1, 6.75975174e-1, 6.81716305e-1, 6.87429962e-1, 6.93115283e-1,
  6.98771407e-1, 7.0439748e-1, 7.09992651e-1, 7.15556073e-1, 7.21086907e-1,
  7.26584315e-1, 7.32047467e-1, 7.37475536e-1, 7.42867702e-1, 7.4822315e-1,
  7.5354107e-1, 7.58820659e-1, 7.64061117e-1, 7.69261652e-1, 7.74421479e-1,
  7.79539817e-1, 7.84615893e-1, 7.89648938e-1, 7.94638193e-1, 7.99582902e-1,
  8.04482319e-1, 8.09335702e-1, 8.14142317e-1, 8.18901439e-1, 8.23612347e-1,
  8.28274329e-1, 8.32886681e-1, 8.37448705e-1, 8.41959711e-1, 8.46419017e-1,
  8.5082595e-1, 8.55179843e-1, 8.59480037e-1, 8.63725883e-1, 8.67916738e-1,
  8.7205197e-1, 8.76130952e-1, 8.80153069e-1, 8.84117711e-1, 8.88024281e-1,
  8.91872186e-1, 8.95660845e-1, 8.99389686e-1, 9.03058145e-1, 9.06665667e-1,
  9.10211707e-1, 9.13695728e-1, 9.17117204e-1, 9.20475618e-1, 9.23770461e-1,
  9.27001237e-1, 9.30167455e-1, 9.33268638e-1, 9.36304317e-1, 9.39274033e-1,
  9.42177336e-1, 9.45013788e-1, 9.4778296e-1, 9.50484434e-1, 9.531178e-1,
  9.55682662e-1, 9.5817863e-1, 9.60605328e-1, 9.62962389e-1, 9.65249456e-1,
  9.67466184e-1, 9.69612237e-1, 9.71687291e-1, 9.73691033e-1, 9.75623159e-1,
  9.77483377e-1, 9.79271407e-1, 9.80986977e-1, 9.82629829e-1, 9.84199713e-1,
  9.85696393e-1, 9.87119643e-1, 9.88469246e-1, 9.89745e-1, 9.90946711e-1,
  9.92074198e-1, 9.9312729e-1, 9.94105827e-1, 9.95009663e-1, 9.9583866e-1,
  9.96592693e-1, 9.97271648e-1, 9.97875422e-1, 9.98403924e-1, 9.98857075e-1,
  9.99234805e-1, 9.99537058e-1, 9.99763787e-1, 9.99914959e-1, 9.99990551e-1,
  9.99990551e-1, 9.99914959e-1, 9.99763787e-1, 9.99537058e-1, 9.99234805e-1,
  9.98857075e-1, 9.98403924e-1, 9.97875422e-1, 9.97271648e-1, 9.96592693e-1,
  9.9583866e-1, 9.95009663e-1, 9.94105827e-1, 9.9312729e-1, 9.92074198e-1,
  9.90946711e-1, 9.89745e-1, 9.88469246e-1, 9.87119643e-1, 9.85696393e-1,
  9.84199713e-1, 9.82629829e-1, 9.80986977e-1, 9.79271407e-1, 9.77483377e-1,
  9.75623159e-1, 9.73691033e-1, 9.71687291e-1, 9.69612237e-1, 9.67466184e-1,
  9.65249456e-1, 9.62962389e-1, 9.60605328e-1, 9.5817863e-1, 9.55682662e-1,
  9.531178e-1, 9.50484434e-1, 9.4778296e-1, 9.45013788e-1, 9.42177336e-1,
  9.39274033e-1, 9.36304317e-1, 9.33268638e-1, 9.30167455e-1, 9.27001237e-1,
  9.23770461e-1, 9.20475618e-1, 9.17117204e-1, 9.13695728e-1, 9.10211707e-1,
  9.06665667e-1, 9.03058145e-1, 8.99389686e-1, 8.95660845e-1, 8.91872186e-1,
  8.88024281e-1, 8.84117711e-1, 8.80153069e-1, 8.76130952e-1, 8.7205197e-1,
  8.67916738e-1, 8.63725883e-1, 8.59480037e-1, 8.55179843e-1, 8.5082595e-1,
  8.46419017e-1, 8.41959711e-1, 8.37448705e-1, 8.32886681e-1, 8.28274329e-1,
  8.23612347e-1, 8.18901439e-1, 8.14142317e-1, 8.09335702e-1, 8.04482319e-1,
  7.99582902e-1, 7.94638193e-1, 7.89648938e-1, 7.84615893e-1, 7.79539817e-1,
  7.74421479e-1, 7.69261652e-1, 7.64061117e-1, 7.58820659e-1, 7.5354107e-1,
  7.4822315e-1, 7.42867702e-1, 7.37475536e-1, 7.32047467e-1, 7.26584315e-1,
  7.21086907e-1, 7.15556073e-1, 7.09992651e-1, 7.0439748e-1, 6.98771407e-1,
  6.93115283e-1, 6.87429962e-1, 6.81716305e-1, 6.75975174e-1, 6.70207439e-1,
  6.6441397e-1, 6.58595644e-1, 6.52753341e-1, 6.46887944e-1, 6.41000339e-1,
  6.35091417e-1, 6.2916207e-1, 6.23213197e-1, 6.17245695e-1, 6.11260467e-1,
  6.05258418e-1, 5.99240456e-1, 5.93207489e-1, 5.87160431e-1, 5.81100196e-1,
  5.75027699e-1, 5.68943859e-1, 5.62849596e-1, 5.56745831e-1, 5.50633486e-1,
  5.44513487e-1, 5.38386758e-1, 5.32254225e-1, 5.26116815e-1, 5.19975458e-1,
  5.1383108e-1, 5.07684611e-1, 5.0153698e-1, 4.95389117e-1, 4.89241951e-1,
  4.83096412e-1, 4.76953428e-1, 4.70813928e-1, 4.64678841e-1, 4.58549094e-1,
  4.52425614e-1, 4.46309327e-1, 4.40201156e-1, 4.34102027e-1, 4.2801286e-1,
  4.21934577e-1, 4.15868096e-1, 4.09814335e-1, 4.03774209e-1, 3.97748631e-1,
  3.91738511e-1, 3.8574476e-1, 3.79768282e-1, 3.73809982e-1, 3.6787076e-1,
  3.61951513e-1, 3.56053138e-1, 3.50176526e-1, 3.44322565e-1, 3.38492141e-1,
  3.32686134e-1, 3.26905422e-1, 3.21150881e-1, 3.15423378e-1, 3.09723782e-1,
  3.04052952e-1, 2.98411747e-1, 2.92801019e-1, 2.87221617e-1, 2.81674384e-1,
  2.76160159e-1, 2.70679775e-1, 2.65234062e-1, 2.59823842e-1, 2.54449933e-1,
  2.49113148e-1, 2.43814294e-1, 2.38554171e-1, 2.33333576e-1, 2.28153297e-1,
  2.23014117e-1, 2.17916814e-1, 2.12862158e-1, 2.07850913e-1, 2.02883837e-1,
  1.97961681e-1, 1.9308519e-1, 1.88255099e-1, 1.8347214e-1, 1.78737036e-1,
  1.74050502e-1, 1.69413247e-1, 1.64825973e-1, 1.60289372e-1, 1.55804131e-1,
  1.51370928e-1, 1.46990432e-1, 1.42663307e-1, 1.38390206e-1, 1.34171776e-1,
  1.30008654e-1, 1.25901469e-1, 1.21850843e-1, 1.17857388e-1, 1.13921708e-1,
  1.10044397e-1, 1.06226043e-1, 1.02467221e-1, 9.87685015e-2, 9.51304424e-2,
  9.1553594e-2, 8.80384971e-2, 8.45856832e-2, 8.11956742e-2, 7.78689827e-2,
  7.46061116e-2, 7.14075543e-2, 6.82737943e-2, 6.52053053e-2, 6.22025514e-2,
  5.92659864e-2, 5.63960544e-2, 5.35931893e-2, 5.08578147e-2, 4.81903443e-2,
  4.55911813e-2, 4.30607187e-2, 4.05993391e-2, 3.82074146e-2, 3.58853068e-2,
  3.36333667e-2, 3.1451935e-2, 2.93413412e-2, 2.73019047e-2, 2.53339336e-2,
  2.34377255e-2, 2.16135671e-2, 1.98617342e-2, 1.81824916e-2, 1.65760932e-2,
  1.50427819e-2, 1.35827895e-2, 1.21963367e-2, 1.08836332e-2, 9.64487731e-3,
  8.48025644e-3, 7.38994662e-3, 6.3741127e-3, 5.43290826e-3, 4.56647559e-3,
  3.77494569e-3, 3.05843822e-3, 2.41706151e-3, 1.85091253e-3, 1.36007687e-3,
  9.44628746e-4, 6.04630957e-4, 3.4013491e-4, 1.51180595e-4, 3.77965773e-5, 0.0,
];
import { FFT } from "dsp.js";

let subscription;
export default {
  name: "marine",
  props: ["user", "goHomeClicked"],
  watch: {
    goHomeClicked: function () {
      // watch it
      if (this.devicesByOwner[0] != null) {
        this.clickDevice(this.devicesByOwner[0]);
      }
    },
  },
  created() {
    if (this.user != ""){
      this.getDevicesByOwner();
      this.getDevicesByType();
    } 
    else {
      setTimeout(this.getDevicesByOwner, 1000); // load owners boxes first
      setTimeout(this.getDevicesByType(), 2000);
      // console.log('delay load');
    }
    
    // this.getDevices();
  },
  components: {
    Plotly,
  },
  data() {
    return {
      devicesByOwner: [],
      selectedDeviceAudioPrivate: false,
      authState: undefined,
      dropdown_class: [
        "Dolphin whistle",
        "Manatee",
        "Boat",
        "Something else",
        "Not Sure",
      ],
      backgroundLabelColor: "blue",
      isFetchingBoxes: true,
      devices: [],
      connectedDevices: [],
      disconnectedDevices: [],
      haikuboxStatus: [],
      cpuTempSeries: [],
      cpuFreqSeries: [],
      signalSeries: [],
      ramdiskSeries: [],
      liveHits: [],
      hits: [],
      allHits: [],
      dailyCounts: [],
      currentSiteName: "",
      currentSerial: "",
      seriesHourly: [],
      seriesSpeciesDaily: [],
      isPlaying: false,
      soundscapes: [],
      fftLength: 512,
      halfLength: 256,
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        width: 300,
        hovermode: false,
      },
      zoom: 3,
      center: latLng(39, -94),
      url: "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
      attribution:
        "Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC",
      currentZoom: 5,
      currentCenter: latLng(39, -94),
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      bounds: latLngBounds([
        [25, -90],
        [29, -75],
      ]),
      iconConnected: icon({
        iconUrl: "./icon.png",
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      iconDisconnected: icon({
        iconUrl: "./signal_wifi_off-24px.svg",
        iconSize: [24, 24],
        iconAnchor: [16, 37],
      }),
      formFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email address",
          required: true,
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Enter password (>7 characters)",
          required: true,
        },
      ],
    };
  },
  methods: {
    labelHit(item) {
      // console.log(item);
      if (!item.classLabel) return;
      const serial = item.serial;
      const dt = item.dt;
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.wav;
      const labeledBy = this.user;
      const label = item.classLabel;
      const score = item.score;
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      // // console.log("link", itemWithUnderscores);
      return itemWithUnderscores;
    },
    play(audioFile) {
      // console.log(audioFile);

      function initAudio() {
        context = new AudioContext();
        source = context.createMediaElementSource(audio);
        compressor = context.createDynamicsCompressor();
        compressor.threshold.value = -40;
        compressor.knee.value = 30;
        compressor.ratio.value = 10;
        compressor.attack.value = 0.25;
        compressor.release.value = 0.25;
        var filter = context.createBiquadFilter();
        filter.type = "highpass";
        filter.frequency.value = 3000;
        source.connect(filter);
        filter.connect(compressor);
        compressor.connect(context.destination);
        audio.crossOrigin = "anonymous";
        audio.autoplay = true;
      }

      if (!context) {
        initAudio();
        if (context.state === "suspended") {
          context.resume();
        }
      }

      Storage.get(audioFile)
        .then((result) => {
          audio.src = result;
          audio.play();
        })
        .catch((err) => console.log(err));
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    getEventText(item) {
      let momentText = moment(item.dt).fromNow();
      if (momentText == "in a few seconds") {
        momentText = "just now";
      }
      return momentText;
    },
    getScoreText(item) {
      let scoreText = "high";
      if (item.score <= 0.3) {
        scoreText = "low";
      } else {
        if (item.score < 0.6) scoreText = "medium";
      }
      return scoreText;
    },
    clickDevice(item) {
      // console.log("clicked", item.id);
      this.liveHits = [];
      this.getPrivacy(item.serial);
      this.getDailyCount(item.serial);
      this.getHourlyCount(item.serial);
      this.getHits(item.serial);
      this.subscribe(item.serial);
      this.getStatus(item.serial);
      this.getSoundscapes(item.serial);
      // this.updateBounds(item.serial);
      this.currentSerial = item.serial;
    },

    async updateBounds(serialClicked) {
      const deviceState = await API.graphql({
        query: getDeviceState,
        variables: { id: serialClicked },
      });
      var clickedDevice = deviceState.data.getDeviceState;
      // // console.log("update bounds clicked", clickedDevice);
      this.bounds = latLngBounds([
        [clickedDevice.lat - 0.5, clickedDevice.lon - 0.5],
        [clickedDevice.lat + 0.5, clickedDevice.lon + 0.5],
      ]);
    },
    async getDevicesByType() {
      const devices = await API.graphql({
        query: haikuboxStateByType,
        variables: { type: "haikumarine" },
      });
      this.devices = devices.data.haikuboxStateByType.items;
      console.log("Devices by type", this.devices);
      this.connectedDevices = [];
      this.disconnectedDevices = [];
      var connected = [];
      var disconnected = [];
      this.devices.forEach(function (element) {
        // console.log(element);
        if ((element.connected === false) & (element.lat != null)) {
          disconnected.push(element);
        }
        if ((element.connected === true) & (element.lat != null)) {
          connected.push(element);
        }
      });
      this.connectedDevices = connected;
      this.disconnectedDevices = disconnected;
      // console.log("connected", connected);
      // console.log("disconnected", disconnected);
      this.isFetchingBoxes = false;
    },

    async getDevicesByOwner() {
      console.log('devicesByOwner', this.user);
      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: this.user },
      });
      this.devicesByOwner = devicesByOwner.data.haikuboxByOwner.items;
      console.log("Devices by owner", this.devicesByOwner);
      if (this.devicesByOwner.length > 0)
        this.clickDevice(this.devicesByOwner[0]);
    },
    async getDevices() {
      const deviceStates = await API.graphql({
        query: listDeviceStates,
      });
      this.devices = deviceStates.data.listDeviceStates.items;
      // console.log("Devices", this.devices);
      this.connectedDevices = [];
      this.disconnectedDevices = [];
      var connected = [];
      var disconnected = [];
      this.devices.forEach(function (element) {
        // console.log(element);
        if ((element.connected === false) & (element.lat != null)) {
          disconnected.push(element);
        }
        if ((element.connected === true) & (element.lat != null)) {
          connected.push(element);
        }
      });
      this.connectedDevices = connected;
      this.disconnectedDevices = disconnected;
      // console.log("connected", connected);
      // console.log("disconnected", disconnected);

      this.isFetchingBoxes = false;
    },
    async getPrivacy(serialClicked) {
      const result = await API.graphql({
        query: haikuboxBySerial,
        variables: { serial: serialClicked },
      });
      // console.log("Privacy", result.data.haikuboxBySerial.items[0]);
      this.currentSiteName = result.data.haikuboxBySerial.items[0].name;
      // if owner, audio is always available
      if (result.data.haikuboxBySerial.items[0].owner === this.user) {
        this.selectedDeviceAudioPrivate = false;
      } else {
        this.selectedDeviceAudioPrivate =
          result.data.haikuboxBySerial.items[0].privateAudio;
        // console.log("Audio Private", this.selectedDeviceAudioPrivate);
      }
    },
    async getStatus(serialClicked) {
      let yesterdayDate = moment.utc().subtract(24, "hours").format();
      const filterArg = {
        serial: serialClicked,
        createdAt: { gt: yesterdayDate },
      };
      const boxStatus = await API.graphql({
        query: statusByDate,
        variables: filterArg,
      });
      this.haikuboxStatus = boxStatus.data.statusByDate.items;
      this.cpuTempSeries = [];

      for (var entry in this.haikuboxStatus) {
        this.cpuTempSeries.push([
          moment
            .utc(this.haikuboxStatus[entry].createdAt)
            .tz(this.devices.find((x) => x.serial === serialClicked).timezone)
            .format("hh:mm a"),
          this.haikuboxStatus[entry].cpuTemp,
        ]);
      }

      this.cpuFreqSeries = [];
      for (entry in this.haikuboxStatus) {
        this.cpuFreqSeries.push([
          moment
            .utc(this.haikuboxStatus[entry].createdAt)
            .tz(this.devices.find((x) => x.serial === serialClicked).timezone)
            .format("hh:mm a"),
          this.haikuboxStatus[entry].cpuFreq,
        ]);
      }

      this.ramdiskSeries = [];
      for (entry in this.haikuboxStatus) {
        this.ramdiskSeries.push([
          moment
            .utc(this.haikuboxStatus[entry].createdAt)
            .tz(this.devices.find((x) => x.serial === serialClicked).timezone)
            .format("hh:mm a"),
          this.haikuboxStatus[entry].ramdisk,
        ]);
      }

      this.signalSeries = [];
      for (entry in this.haikuboxStatus) {
        this.signalSeries.push([
          moment
            .utc(this.haikuboxStatus[entry].createdAt)
            .tz(this.devices.find((x) => x.serial === serialClicked).timezone)
            .format("hh:mm a"),
          this.haikuboxStatus[entry].signal,
        ]);
      }
      //// console.log("cpu freq", this.cpuFreqSeries);
      // // console.log("temp", this.cpuTempSeries);
      // // console.log("status", this.haikuboxStatus);
    },
    async getDailyCount(serialClicked) {
      let lastMonthDate = moment.utc().subtract(31, "days").format();
      const filterArg = {
        serial: serialClicked,
        date: { gt: lastMonthDate },
      };
      const dailyCounts = await API.graphql({
        query: dailyCountBySerialByDate,
        variables: filterArg,
        limit: 30,
      });
      this.dailyCounts = dailyCounts.data.dailyCountBySerialByDate.items;
      // console.log("Daily Counts Query", this.dailyCounts);
      let speciesList = [];
      let dateList = [];
      let entry = {};
      for (entry in this.dailyCounts) {
        speciesList.push(...this.dailyCounts[entry].spCode);
        dateList.push(this.dailyCounts[entry].date);
      }

      // clear chart if no data
      if (speciesList.length == 0) {
        // console.log("no data");
        this.seriesDaily = [];
        this.chartOptions = {
          xaxis: {
            categories: [],
          },
        };
        return;
      }

      // Create date array in case dates with no results
      let minDate = dateList.reduce(function (a, b) {
        return a < b ? a : b;
      });
      let maxDate = dateList.reduce(function (a, b) {
        return a > b ? a : b;
      });

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
      }
      let dateArr = getDates(minDate, maxDate);

      function getShortDates(startDate, stopDate) {
        var shortDateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          shortDateArray.push(moment(currentDate).format("MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return shortDateArray;
      }
      let shortDateArr = getShortDates(minDate, maxDate);

      // Remove duplicates from species list
      speciesList = Array.from(new Set(speciesList));
      // console.log("dateArr", dateArr);
      // console.log("speciesList", speciesList);
      let nrows = speciesList.length;
      let ncolumns = dateArr.length;

      // create array with zeros for species counts
      let countArray = new Array(nrows);
      for (let i = 0; i < countArray.length; i++) {
        countArray[i] = new Array(ncolumns).fill(0);
      }
      // // console.log(countArray);

      // loop through all days
      // for each entry figure out date index
      // loop through each species for that date and put in array
      for (entry in this.dailyCounts) {
        let newDate = moment(this.dailyCounts[entry].date).format("YYYY-MM-DD");
        let dateIndex = dateArr.indexOf(newDate);
        let species = {};
        for (species in this.dailyCounts[entry].spCode) {
          //  console.log("species", species);
          let speciesIndex = speciesList.indexOf(
            this.dailyCounts[entry].spCode[species]
          );
          // console.log(dateIndex, speciesIndex);
          countArray[speciesIndex][dateIndex] =
            this.dailyCounts[entry].count[species];
        }
      }
      this.seriesDaily = [];
      var sortOrder = Array.from(Array(speciesList.length).keys()).sort(
        (a, b) =>
          speciesList[a] > speciesList[b]
            ? -1
            : (speciesList[b] > speciesList[a]) | 0
      );
      // console.log("sorted", sortOrder);
      for (let i = 0; i < nrows; i++) {
        this.seriesDaily.push({
          name: speciesList[sortOrder[i]],
          data: countArray[sortOrder[i]],
        });
      }

      this.chartOptionsDaily = {
        xaxis: {
          categories: dateArr,
        },
      };
      this.chartOptionsSpeciesDaily = {
        xaxis: {
          categories: shortDateArr,
        },
      };
      // console.log("daily x-axis", this.chartOptionsDaily.xaxis.categories);
      // console.log("seriesDaily", this.seriesDaily);
    },

    async getHourlyCount(serialClicked) {
      let yesterdayDate = moment.utc().subtract(1, "hours").format();
      const filterArg = {
        serial: serialClicked,
        date: { gt: yesterdayDate },
      };
      const hourlyCounts = await API.graphql({
        query: itemsBySerialByDate,
        variables: filterArg,
        limit: 24,
      });
      this.hourlyCounts = hourlyCounts.data.itemsBySerialByDate.items;
      // console.log("hourly counts", this.hourlyCounts);

      let speciesList = [];
      let dateList = [];
      let entry = {};
      for (entry in this.hourlyCounts) {
        speciesList.push(...this.hourlyCounts[entry].spCode);
        dateList.push(this.hourlyCounts[entry].date);
      }

      // console.log("Hourly Date list", dateList);

      // clear chart if no data
      if (speciesList.length == 0) {
        // console.log("no data");
        this.seriesHourly = [];
        this.chartOptions = {
          xaxis: {
            categories: [],
          },
        };
        return;
      }

      // Create date array in case dates with no results
      let minDate = dateList.reduce(function (a, b) {
        return a < b ? a : b;
      });
      let maxDate = dateList.reduce(function (a, b) {
        return a > b ? a : b;
      });

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate).utc();
        stopDate = moment(stopDate).utc();
        // console.log("start date", startDate);
        // console.log("stop date", stopDate);
        while (currentDate <= stopDate) {
          var a = moment.utc(currentDate);
          dateArray.push(a.format());
          currentDate = moment(currentDate).add(1, "hours");
        }
        return dateArray;
      }
      let dateArr = getDates(minDate, maxDate);
      // console.log("hourly date array", dateArr);

      // Remove duplicates from species list
      speciesList = Array.from(new Set(speciesList));
      // console.log("species", speciesList);
      let nrows = speciesList.length;
      let ncolumns = dateArr.length;

      // create array with zeros for species counts
      let countArray = new Array(nrows);
      for (let i = 0; i < countArray.length; i++) {
        countArray[i] = new Array(ncolumns).fill(0);
      }
      // console.log("counts", countArray);

      // loop through all hours
      // for each entry figure out date index
      // loop through each species for that date and put in array
      for (entry in this.hourlyCounts) {
        let newDate = moment(this.hourlyCounts[entry].date).utc().format();
        let dateIndex = dateArr.indexOf(newDate);
        let species = {};
        for (species in this.hourlyCounts[entry].spCode) {
          let speciesIndex = speciesList.indexOf(
            this.hourlyCounts[entry].spCode[species]
          );
          countArray[speciesIndex][dateIndex] =
            this.hourlyCounts[entry].count[species];
        }
      }
      this.seriesHourly = [];
      var sortOrder = Array.from(Array(speciesList.length).keys()).sort(
        (a, b) =>
          speciesList[a] > speciesList[b]
            ? -1
            : (speciesList[b] > speciesList[a]) | 0
      );
      for (let i = 0; i < nrows; i++) {
        this.seriesHourly.push({
          name: speciesList[sortOrder[i]],
          data: countArray[sortOrder[i]],
        });
      }

      //  console.log(
      //   "Looking for tz",
      //   this.devices.find((x) => x.serial === serialClicked).timezone
      // );
      let localDateArr = [];
      for (let utcDate of dateArr) {
        localDateArr.push([
          moment
            .utc(utcDate)
            .tz(this.devices.find((x) => x.serial === serialClicked).timezone)
            .format("hh:mm a"),
        ]);
      }

      this.chartOptionsHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };

      this.chartOptionsSpeciesHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };
      // console.log("hourly x-axis", this.chartOptionsHourly.xaxis.categories);
      // console.log("seriesHourly", this.seriesHourly);
    },

    // for charts.js plots
    getHourlySpecies(speciesID) {
      let obj = this.seriesHourly.find((o) => o.name === speciesID);
      if (obj === undefined) {
        // console.log("No hourly counts for ", speciesID);
        return [];
      }
      var plotData = [];
      for (var index in obj.data) {
        plotData.push([
          this.chartOptionsSpeciesHourly.xaxis.categories[index],
          obj.data[index],
        ]);
      }
      //// console.log("plotData", plotData);
      return plotData;
    },

    getHourlySpeciesCount(speciesID) {
      let obj = this.seriesHourly.find((o) => o.name === speciesID);
      if (obj === undefined) {
        return 0;
      }
      const arrSum = (arr) => arr.reduce((a, b) => a + b, 0);
      return arrSum(obj.data);
    },

    // for charts.js plots
    getDailySpecies(speciesID) {
      console.log("getDailySpecies", speciesID);
      let obj = this.seriesDaily.find((o) => o.name === speciesID);
      if (obj === undefined) {
        console.log("No daily counts for ", speciesID);
        return [];
      }
      var plotData = [];
      for (var index in obj.data) {
        plotData.push([
          this.chartOptionsSpeciesDaily.xaxis.categories[index],
          obj.data[index],
        ]);
      }
      console.log("plotData", plotData);
      return plotData;
    },

    getDailySpeciesCount(speciesID) {
      let obj = this.seriesDaily.find((o) => o.name === speciesID);
      if (obj === undefined) {
        return 0;
      }
      const arrSum = (arr) => arr.reduce((a, b) => a + b, 0);
      return arrSum(obj.data);
    },
    async getSoundscapes(serialClicked) {
      let yesterdayDate = moment.utc().subtract(24, "hours").format();
      const variableArg = {
        serial: serialClicked,
        wav: { gt: "" },
        sortDirection: "DESC",
        dt: { gt: yesterdayDate },
      };
      const hits = await API.graphql({
        query: rawHaikumarineBySerialByDate,
        variables: variableArg,
      });
      this.soundscapes = hits.data.rawHaikumarineBySerialByDate.items;
      console.log("soundscapes", this.soundscapes);
    },
    async getHits(serialClicked) {
      // console.log("getHits", serialClicked);
      let yesterdayDate = moment.utc().subtract(24, "hours").format();
      const filterArg = {
        serial: serialClicked,
        wav: { gt: "" },
        sortDirection: "DESC",
        dt: { gt: yesterdayDate },
      };
      const hits = await API.graphql({
        query: hitBySerialByDate,
        variables: filterArg,
      });
      this.hits = hits.data.hitBySerialByDate.items;
      this.allHits = this.hits;

      for (i in this.hits) {
        this.hits[i].window = "image";
      }

      // // leave one per species in allHits--used for help Haikubox
      // var i;
      // var helpHits = [];
      // var helpHitsIndex = [];
      // for (i = this.hits.length - 1; i >= 0; i--) {
      //   if (!helpHits.includes(this.hits[i].cn)) {
      //     helpHits.push(this.hits[i].cn);
      //     helpHitsIndex.push(i);
      //   }
      // }

      // var uniqueHelpHits = [];
      // for (i in helpHitsIndex) {
      //   uniqueHelpHits.push(this.hits[helpHitsIndex[i]]);
      // }
      // this.allHits = uniqueHelpHits;

      // keep track of species in list
      var speciesHits = [];
      var speciesIndex = [];
      for (var i = 0; i < this.hits.length; i++) {
        if (!speciesHits.includes(this.hits[i].spCode)) {
          speciesHits.push(this.hits[i].spCode);
          speciesIndex.push(i);
        }
      }
      var uniqueHits = [];
      for (i in speciesIndex) {
        uniqueHits.push(this.hits[speciesIndex[i]]);
      }
      // console.log("Hits", uniqueHits);
      this.hits = uniqueHits;
    },
    subscribe(serialClicked) {
      if (subscription) {
        // console.log("unsubscribing");
        subscription.unsubscribe();
      }
      // console.log("subscribe");
      subscription = API.graphql({
        query: onCreateHit,
        variables: { serial: serialClicked },
      }).subscribe({
        next: (eventData) => {
          // console.log(eventData);
          let liveHit = eventData.value.data.onCreateHit;
          if (this.liveHits.some((item) => item.id === liveHit.id)) return; // remove duplications
          this.liveHits = [liveHit, ...this.liveHits];
          this.liveHits = this.liveHits.slice(0, 10); // limit to 10 hits
        },
      });
    },
    setWindow(index, value) {
      this.hits[index].window = value;
      this.hits[index].id += 1; // increment ID so that component updates

      // console.log("Change Window", this.hits[index]);
    },
    spectrogram(index, audioFile, pageType) {
      console.log("Spectrogram", audioFile);

      // if (!context) {
      //   if (context.state === "suspended") {
      //     context.resume();
      //   }
      // }

      async function getFile(audioContext, filepath) {
        // webkit audio decodeAudioData does not work in Safari
        // const response = await fetch(filepath);
        // const arrayBuffer = await response.arrayBuffer();
        // const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        // return audioBuffer;

        // standardized-audio-context from npm
        const nativeAudioContext = new AudioContext();
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          nativeAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        var context = new AudioContext();
        const sample = await getFile(context, filePath);

        return sample;
      }

      function linear2Decibel(value) {
        var dB = 20 * Math.log10(value);
        return dB;
      }

      //var c = document.getElementById("myCanvas");
      //this.canvas = c.getContext("2d");

      Storage.get(audioFile)
        .then(
          (result) => {
            // console.log("Storage get", result);

            setupSample(result)
              .then((sample) => {
                // console.log("sample", sample);
                let signal = sample.getChannelData(0);
                // console.log("raw", signal);

                // calculate spectrogram
                // let ts = 0;
                let overlap = 0.0;
                let fftLength = this.fftLength;
                let halfLength = this.halfLength;
                let offset = Math.floor(fftLength * (1.0 - overlap));
                // console.log("offset", offset);
                // let ctx = this.canvas;
                let fft = new FFT(fftLength, 44100);
                var spectrogramArray = [];
                for (var x = 0; x < sample.length - fftLength; x += offset) {
                  var chunk = signal.slice(x, x + fftLength);
                  for (var i = 0; i < fftLength; i++) {
                    chunk[i] = chunk[i] * hann[i];
                  }
                  fft.forward(chunk);
                  chunk = fft.spectrum.slice(0, halfLength);
                  // console.log("fft", chunk);
                  var dBmag = chunk.map(linear2Decibel);
                  // console.log("dB", dBmag);
                  spectrogramArray.push(...dBmag);
                }

                // console.log("linear spec", spectrogramArray);

                // arrange spectrogram for Plotly
                var spectrogramData = [];
                for (i = 0; i < halfLength; i++) {
                  // grab one element every halfLength points
                  var arr = spectrogramArray.filter(function (value, j) {
                    return j % halfLength == 0;
                  });
                  spectrogramData.push(arr);
                  spectrogramArray.shift(); // remove first element
                }

                if (pageType === "Recent") {
                  this.hits[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: -70,
                    },
                  ];
                  // console.log("spec", this.hits[index].spectrogram);
                  this.setWindow(index, "spectrogram");
                }

                if (pageType === "Soundscape") {
                  this.soundscapes[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: -70,
                    },
                  ];
                  // console.log("spec", this.hits[index].spectrogram);
                  this.soundscapes[index].window = "spectrogram";
                  this.soundscapes[index].id += 1; // increment ID so that component updates
                }
              })
              .catch((err) => {
                console.log(err);
                console.log("No audio", audioFile);
                // console.log("Delete index", index);
                this.snackbar = true;
                return false;
              });
          },
          (reason) => {
            // rejection
            console.log("Can't play ", reason);
          }
        )
        .catch((err) => {
          console.log("Storage error", err);
        });
    },
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
@import url("https://fonts.googleapis.com/css?family=Quicksand");
#haikumarine {
  font-family: Quicksand, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 0;
  box-sizing: border-box;  */
}
header {
  font-family: Quicksand;
  /* display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background-color: #212121;
  color: #fff; */
}
main {
  min-height: 100%;
  overflow: hidden;
  /* background-color: #ffe; */
  justify-content: center;
  align-items: center;
}
</style>
